import React, {Component} from 'react';
import {observable, action} from 'mobx';
import { observer, inject } from 'mobx-react';
import { srcToWebP } from 'webp-converter-browser'
import { convertVideoToAnimatedWebp } from "../../../utils/mediaConvert";
import {Common as util} from "../../../utils/common";
import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import HelpButton from "../../../components/common/HelpButton";
import guideManager from "../../../guides/guideManager";
import ModalLoading from "../../../components/common/ModalLoading";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
  FormTextarea,
  FormSelect,
  Modal,
  ModalBody,
  FormInput,
  Button
} from "shards-react";
import moment from "moment";
import DateTimePicker from 'react-datetime-picker';
import {reactLocalStorage as Storage} from "reactjs-localstorage";

let imgOptimizationType = 'canvas';//webp, canvas
let imgOptimizationQuality = 0.8;//webp, canvas

@inject(({ common }) => ({ getUploadUrl: common.getUploadUrl, base64UploadImages: common.base64UploadImages, cafe24UploadFiles: common.cafe24UploadFiles, uploadImg: common.uploadImg, removeMedia: common.removeMedia, getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me , checkOrder:teamUser.checkOrder, checkOrderShop: teamUser.checkOrderShop}))
@inject(({ product }) => ({ getProductList: product.getProductList, getCafe24ProductOptions: product.getCafe24ProductOptions, setProductSync: product.setProductSync, updateProductReplay: product.updateProductReplay }))
@inject(({ review }) => ({ updateReview:review.updateReview, getAnalysisList:review.getAnalysisList, genAIReviewAnalysis:review.genAIReviewAnalysis, getSurveyReviewList:review.getSurveyReviewList, getSurveyProductGroupList:review.getSurveyProductGroupList }))

@observer
class ReviewWrite extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //list
  @observable listParams = {
    page:1, limit:20,
  }
  @observable searchParams = {
    keyword: '',
    overReviewCount: '',
  };
  @observable list = [];

  //modals
  @observable modals = {
    data: null,
    isWriteForm: false,
    widgetData: {},
    isMakeWidgetModal: false
  };

  @observable widgetUrl;
  fileInputRef = React.createRef();
  @observable isDragOverUpload = false;

  @observable categories = [];

  @observable newReview = {};

  // 상품 옵션 (리뷰 작성 시 선택) — cafe24 옵션 조회 결과로 채워짐
  @observable productOptionDefs = [];   // [{ name, required, values: [..] }]
  @observable selectedOptions = {};     // { 옵션명: 선택값 }
  @observable optionsLoading = false;

  // @observable isShowCalendar = {
  //   createdAt: false
  // };

  @observable isShowCollapse = false;
  @observable isUploading = false;

  // 설문 리뷰 관련
  @observable surveyTree = [];  // 공통 설문 (isCommon)
  @observable surveyProductGroups = [];  // 상품별 설문 그룹
  @observable allSurveyGroups = [];  // 전체 설문지 목록
  @observable productSurvey = [];  // 현재 상품에 적용된 설문
  @observable surveyAnswers = {};

  // 리디자인: 추가 상태
  @observable showWarning = true;          // 1단계: 경고 배너 (sessionStorage 기반)
  @observable warningAgreed = false;       // 책임 동의 체크박스 상태
  @observable hoveredGoodsPt = 0;          // 6단계: 별점 호버 미리보기 (상품)
  @observable hoveredDeliveryPt = 0;       // 6단계: 별점 호버 미리보기 (배송)
  @observable showAdvancedUpload = false;  // (사용 안 함, 호환용으로 보존)

  // 8단계 신규: RMBG-1.4 브라우저 배경 제거
  @observable bgRemovalEnabled = false;    // 토글
  @observable bgRemovalModelLoading = false; // 모델 최초 로딩
  @observable bgRemovalLoadProgress = 0;   // 모델 로딩 % (0~100)
  @observable bgRemovalProcessing = false; // 이미지 처리 중
  @observable bgRemovalProgress = { current: 0, total: 0, fileName: '' };



  constructor(props) {
    super(props);
    this.init()

    this.onChangeValue = this.onChangeValue.bind(this);
  }

  handleDropAreaClick = () => {
    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  @action
  handleDragOverUpload = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    if (!this.isDragOverUpload) {
      this.isDragOverUpload = true;
    }
  };

  @action
  handleDragLeaveUpload = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.isDragOverUpload) {
      this.isDragOverUpload = false;
    }
  };

  @action
  handleDropUpload = async (event) => {
    if (this.blockExpired()) return;
    event.preventDefault();
    event.stopPropagation();
    this.isDragOverUpload = false;

    const files = Array.from(event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : []);
    const allowedFiles = files.filter(file => {
      if (!file.type) {
        return false;
      }
      if (file.type.startsWith('image/')) {
        return true;
      }
      return file.type === 'video/mp4' || file.type === 'video/quicktime';
    });

    if (allowedFiles.length === 0) {
      toast('이미지 또는 MP4/MOV 영상 파일만 업로드할 수 있습니다.');
      return;
    }

    try {
      await this.onFileUpload(undefined, allowedFiles);
    } catch (error) {
      console.error('드롭 업로드 중 오류:', error);
    }

    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };


  componentDidUpdate(prevProps, prevState){

  }

  // === 사용기간 만료 시 리뷰 작성 기능 차단 (reviewList 과 동일 처리) ===
  @observable isExpired = false;

  computeExpired = (d) => {
    if (!d) return false;
    if (moment(d).year() >= 2999) return false;   // 자동결제(무기한) sentinel → 유효
    return moment(d).isBefore(moment());
  };

  // 선택 샵의 최신 사용기간 조회해 만료 여부 갱신 (경고/리다이렉트 없는 판정 전용)
  refreshExpiry = async () => {
    try {
      if (!this.store || !this.store._id) return;
      const shopNo = (this.teamUser && this.teamUser.selShopNo) ? this.teamUser.selShopNo : 1;
      const updated = await this.props.checkOrder({ store_id: this.store._id, shopNo });
      if (updated && updated.data && updated.data.useExpiryDate) {
        this.store.useExpiryDate = updated.data.useExpiryDate;
      }
      this.isExpired = this.computeExpired(this.store.useExpiryDate);
    } catch (e) {
      this.isExpired = false;   // 판정 실패 시 차단하지 않음(안전측)
    }
  };

  blockExpired = () => {
    if (this.isExpired) {
      toast.error('서비스 사용 기간이 만료되어 리뷰 작성 기능을 이용할 수 없습니다. 연장 후 이용해 주세요.');
      return true;
    }
    return false;
  };

  @action
  init = async (key) => {
    if(this.props.isLogin) {
      let _this = this;
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.shop = this.props.me.shop ? this.props.me.shop : {};
      this.permissions = this.props.me.permissions;

      this.refreshExpiry();   // 선택 샵 사용기간 만료 여부 확인 (만료 시 리뷰 작성 기능 차단)

      // if(this.shop.orderType === "free") {
      //   alert('무료 버전에서는 해당 기능 지원이 불가능합니다.');
      //   window.location.href = '/inAppOrder';
      // }

      // if(!this.store.isFreeStore) {
      //   this.checkOrder();
      // }
      // else {
      //   this.checkOrder();
      // }

      // 리뷰 부스터 애드온 게이팅 제거 — 단일 리뷰 작성은 무료 기능으로 전환
      this.isUse = true;

      // 유의사항 동의 여부 — sessionStorage 체크
      this.checkWarningAgreement();

      // if(this.store.presidentName !== "윤정진") {
      //   let isConfirm = window.confirm("해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 책임이 있습니다.")
      //   if(!isConfirm) {
      //     window.history.back();
      //   }
      // }

      this.props.getDoc('getCategories', { store_id:this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1 }, function(res) {
        _this.categories = (res && res.data && res.data.categoriesData) ? res.data.categoriesData : [];
      });
      // console.log(this.categories);

      this.initNewReview();
      this.loadSurveyTree();
      this.listParams.store_id = this.teamUser.selStore_id;
      this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      this.listParams.limit = parseInt(await Storage.get('limitReviewWriteList')) || this.listParams.limit;
      //this.listParams.teamUserId = this.teamUser.id;

      //url params
      for (const key of this.urlParams.keys()) {
        if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
          this.listParams[key] = parseInt(this.urlParams.get(key));
        }
        else {
          this.searchParams[key] = this.urlParams.get(key);
        }
      }

      this.getProductList();
    }

    if(this.teamUser.email === "admin@onnomads.com") {
      let _this = this;
      function generateRandomId(length) {
        const characters = 'abcdefghijklmnopqrstuvwxyz';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      }

      // 100개의 랜덤 ID 배열을 생성하는 함수
      function generateNamesArray(size, length) {
        const namesArray = [];
        for (let i = 0; i < size; i++) {
          namesArray.push(generateRandomId(length));
        }
        return namesArray;
      }

      // 특정 배열 정의
      var namesArray = generateNamesArray(100, 8);

      let lastClipboardContent = '';

      // 클립보드 내용을 주기적으로 확인하는 함수
      function checkClipboard() {
        navigator.clipboard.readText().then(text => {
          if (text && text !== lastClipboardContent) {
            lastClipboardContent = text;
            handleClipboardChange(text);
          }
        }).catch(err => {
          //console.error('Failed to read clipboard contents: ', err);
        });
      }


      // 클립보드 변경을 처리하는 함수
      function handleClipboardChange(text) {
        _this.newReview.contents = text;
        var randomName = namesArray[Math.floor(Math.random() * namesArray.length)];
        console.log(randomName)

        _this.newReview.writerName = randomName;
        // 추가 작업 처리
      }

      setInterval(checkClipboard, 2000);


    }

  };

  checkOrder = async (shopNo) => {
    let updatedStore = await this.props.checkOrder({store_id: this.store._id, shopNo: shopNo ? shopNo: 1});
    if(updatedStore.data && updatedStore.data.useExpiryDate) {
      this.store.useExpiryDate = updatedStore.data.useExpiryDate;
      this.store.useExpiryDateDiffNow = moment(moment(this.store.useExpiryDate).format('YYYY.MM.DD')).diff(moment(), 'days')+1;

    }
    else {
      // alert('무료 버전에서는 해당 기능 지원이 불가능합니다.');
      // window.location.href = '/inAppOrder';
    }


    
    if(this.store.useExpiryDateDiffNow < -5) {
      if(this.store.useExpiryDateDiffNow > 0) {
        alert('서비스 사용 기간이 '+this.store.useExpiryDateDiffNow+'일 남았습니다.') ;
      }
      else if(this.store.useExpiryDateDiffNow > -7) {
        alert('서비스 사용 기간이 '+Math.abs(this.store.useExpiryDateDiffNow)+'일 지났습니다. 서비스 연장을 진행해 주세요.') ;
      }
      else if(this.store.useExpiryDateDiffNow > -14) {
        alert('서비스 사용 기간이 '+Math.abs(this.store.useExpiryDateDiffNow)+'일 지났습니다. 일부 기능이 제한됩니다. 정상적인 서비스 사용을 위해 연장을 진행해 주세요.') ;
      }
      else  {
        alert('서비스 사용 기간이 '+Math.abs(this.store.useExpiryDateDiffNow)+'일 지났습니다. 서비스 이용을 위해 연장을 진행해 주세요.') ;
        window.location.href = '/inAppOrder';
      }
    }
  };

  initNewReview = async () => {
    this.newReview = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      teamUser_id: this.teamUser.id,
      product_id: '',
      platform: this.store.platform,
      orderProductOptions: '',
      displayStatus: 2,
      goodsPt: 100,
      deliveryPt: 100,
      isSecret: false,
      isShow: true,
      isMobile: false,
      isDelete: false,
      images: [],
      thumbs: [],
      movies: [],
      isGuest: false,
      isAdmin: true,
      isMember: false,
      writerId: '',
      writerName: '',
      writerPw: this.teamUser.emailId,
      subject: '',
      contents: '',
      fromWrite: '일반리뷰',
      createdAt: moment()._d,
      displayAt: moment()._d
    }
    this.surveyAnswers = {};
    this.productOptionDefs = [];
    this.selectedOptions = {};
    this.optionsLoading = false;
  };

  @action
  loadSurveyTree = async () => {
    let _this = this;

    // 1. 전체 설문지 목록 가져오기 (공통 설문 포함)
    this.props.getSurveyReviewList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      type: 'group',
      limit: 100,
      page: 1
    }, function(res) {
      if (res && res.docs) {
        _this.allSurveyGroups = res.docs;
        // 공통 설문 (isCommon)만 별도 저장
        _this.surveyTree = res.docs.filter(function(group) {
          return group.isCommon === true;
        });
      }
    });

    // 2. 상품별 설문 그룹 가져오기
    this.props.getSurveyProductGroupList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      limit: 100,
      page: 1
    }, function(res) {
      if (res && res.docs) {
        _this.surveyProductGroups = res.docs;
      }
    });
  };

  // 상품에 해당하는 설문 가져오기
  @action
  loadSurveyForProduct = async (product) => {
    let _this = this;
    this.surveyAnswers = {};
    this.productSurvey = [];

    // surveyConfig.enableSurvey가 'yes'가 아니면 설문 로드하지 않음
    const surveyConfig = this.teamUser.basicSettings && this.teamUser.basicSettings.surveyConfig;
    if (!surveyConfig || surveyConfig.enableSurvey !== 'yes') {
      return;
    }

    if (!product) {
      this.productSurvey = this.surveyTree;
      return;
    }

    // 전체 설문지 목록 가져오기
    await new Promise((resolve) => {
      this.props.getSurveyReviewList({
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        type: 'group',
        limit: 100,
        page: 1
      }, function(res) {
        if (res && res.docs) {
          _this.allSurveyGroups = res.docs;
          _this.surveyTree = res.docs.filter(function(group) {
            return group.isCommon === true;
          });
        }
        resolve();
      });
    });

    // 상품별 설문 그룹 가져오기
    await new Promise((resolve) => {
      this.props.getSurveyProductGroupList({
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        limit: 100,
        page: 1
      }, function(res) {
        if (res && res.docs) {
          _this.surveyProductGroups = res.docs;
        }
        resolve();
      });
    });

    // 결과 배열: 공통 설문을 먼저 추가
    let resultSurveys = [...this.surveyTree];

    // 상품이 속한 설문 그룹 찾기
    let matchedGroup = null;
    for (let group of this.surveyProductGroups) {
      if (group.product_ids && group.product_ids.length > 0) {
        const found = group.product_ids.find(function(p) {
          return p._id === product._id || p.platformProductId === product.platformProductId;
        });
        if (found && group.surveyReview_id) {
          matchedGroup = group;
          break;
        }
      }
    }

    if (matchedGroup && matchedGroup.surveyReview_id) {
      // 상품별 설문이 있는 경우 추가
      const survey = this.allSurveyGroups.find(function(s) {
        return s._id === matchedGroup.surveyReview_id;
      });
      if (survey && !survey.isCommon) {
        // 공통 설문이 아닌 경우에만 추가 (중복 방지)
        resultSurveys.push(survey);
        console.log('상품별 설문 추가:', survey.name);
      }
    }

    _this.productSurvey = resultSurveys;

    // rating 타입 질문의 기본값 설정 (100 = 별 5개)
    for (let group of resultSurveys) {
      if (group.item_ids && group.item_ids.length > 0 && typeof group.item_ids[0] === 'object') {
        for (let item of group.item_ids) {
          const questionType = item.options && item.options.questionType ? item.options.questionType : 'text';
          if (questionType === 'rating') {
            _this.surveyAnswers[item._id] = 100;
          }
        }
      }
    }

    console.log('총 설문 개수:', _this.productSurvey.length, '개 (공통:', _this.surveyTree.length, '개)');
  };

  @action
  onChangeSurveyAnswer = (itemId, value, type, maxSelections) => {
    if (type === 'checkbox') {
      if (!this.surveyAnswers[itemId]) {
        this.surveyAnswers[itemId] = [];
      }
      const idx = this.surveyAnswers[itemId].indexOf(value);
      if (idx > -1) {
        this.surveyAnswers[itemId].splice(idx, 1);
      } else {
        if (maxSelections && this.surveyAnswers[itemId].length >= maxSelections) {
          toast(`최대 ${maxSelections}개까지 선택 가능합니다.`);
          return;
        }
        this.surveyAnswers[itemId].push(value);
      }
    } else {
      this.surveyAnswers[itemId] = value;
    }
  };

  onChangeValue = async (event) => {
    const { name, value } = event.target;
    if(name === 'password') {
      this.newReview[name] = value;
    }
    else {
      this.newReview[name] = value;
    }
  };

  onChangeCalendarValue = async (date, dateType) => {
    console.log(date)
    if(date) {
      this.newReview[dateType] = moment(date)._d;
    }
    else {
      this.newReview[dateType] = moment()._d;
    }

  };

  onAddDateTime = async (add, unit, dateType) => {
    let date = moment(this.newReview[dateType]).add(add, unit);
    this.newReview[dateType] = date._d;
  };

  // 리디자인: 별점 헬퍼
  @action
  setRating = (field, value) => {
    this.newReview[field] = value;
  }

  @action
  setHoverRating = (field, value) => {
    if (field === 'goodsPt') this.hoveredGoodsPt = value;
    else if (field === 'deliveryPt') this.hoveredDeliveryPt = value;
  }

  // 리디자인: 검색 필터 초기화
  @action
  resetSearchFilters = () => {
    this.searchParams.category = '';
    this.searchParams.keyword = '';
    this.searchParams.overReviewCount = '';
    this.search();
  }

  @action
  clearSearchFilter = (key) => {
    this.searchParams[key] = '';
    this.search();
  }

  // 리디자인: 현재 시간으로 설정
  @action
  setNowDateTime = (dateType) => {
    this.newReview[dateType] = moment()._d;
  }

  // 리디자인: 작성자 ID 자동 재생성 (랜덤)
  @action
  regenerateWriterId = () => {
    const rand = Math.random().toString(36).slice(2, 10);
    this.newReview.writerId = `auto_${rand}`;
  }

  // 리디자인: 별점 라벨 변환
  rateToScore = (pt) => {
    if (!pt) return 0;
    return parseInt(pt) / 20;
  }

  // 유의사항 배너 — sessionStorage 기반 정책
  // 한 번 동의하면 같은 브라우저 세션 동안 다시 노출 안 함
  // 새 세션(브라우저/탭 종료 후 재진입) → 다시 동의 필요
  WARNING_STORAGE_KEY = 'reviewWrite_warningAgreed';

  @action
  checkWarningAgreement = () => {
    try {
      const agreed = sessionStorage.getItem(this.WARNING_STORAGE_KEY);
      if (agreed === 'true') {
        this.showWarning = false;
        this.warningAgreed = true;
      }
    } catch (e) {
      // sessionStorage 사용 불가(브라우저 차단 등) → 메모리 only
      console.warn('sessionStorage 사용 불가, 메모리 모드로 동작');
    }
  }

  @action
  toggleWarningAgree = () => {
    this.warningAgreed = !this.warningAgreed;
  }

  @action
  dismissWarning = () => {
    if (!this.warningAgreed) return;
    this.showWarning = false;
    try {
      sessionStorage.setItem(this.WARNING_STORAGE_KEY, 'true');
    } catch (e) {
      console.warn('sessionStorage 저장 실패:', e);
    }
  }

  // ============================================================
  // RMBG-1.4 브라우저 배경 제거 (Transformers.js + CDN dynamic import)
  // ============================================================
  // 모델/프로세서 캐시 — 첫 호출 후 메모리 유지
  _bgRemovalCache = { model: null, processor: null, RawImage: null };

  loadBgRemovalPipeline = async () => {
    if (this._bgRemovalCache.model && this._bgRemovalCache.processor) {
      return this._bgRemovalCache;
    }

    this.bgRemovalModelLoading = true;
    this.bgRemovalLoadProgress = 0;

    try {
      // CDN 기반 dynamic import — webpack 우회
      // editpixel 검증된 패턴: @huggingface/transformers@3 + webpackIgnore
      const cdnUrl = 'https://cdn.jsdelivr.net/npm/@huggingface/transformers@3';
      console.log('[RMBG] transformers 로드 시작:', cdnUrl);
      // CRA의 babel/webpack이 동적 import를 변환하지 못하도록 Function 우회 — eval 룰 의도적 우회
      // eslint-disable-next-line no-new-func
      const transformers = await new Function('u', 'return import(/* webpackIgnore: true */ u)')(cdnUrl);
      console.log('[RMBG] transformers 로드 완료');

      transformers.env.allowLocalModels = false;

      const progressCb = (p) => {
        if (p && p.status === 'progress' && typeof p.progress === 'number') {
          this.bgRemovalLoadProgress = Math.round(p.progress);
        }
        if (p && p.status === 'done') {
          console.log('[RMBG] 파일 다운로드 완료:', p.file);
        }
      };

      console.log('[RMBG] 모델 + 프로세서 다운로드 시작 (briaai/RMBG-1.4)...');
      // editpixel 검증된 호출 방식: 단순화된 from_pretrained, 커스텀 config 없음
      const [model, processor] = await Promise.all([
        transformers.AutoModel.from_pretrained('briaai/RMBG-1.4', {
          dtype: 'fp32',
          progress_callback: progressCb
        }),
        transformers.AutoProcessor.from_pretrained('briaai/RMBG-1.4', {
          progress_callback: progressCb
        })
      ]);
      console.log('[RMBG] 모델 + 프로세서 로드 완료, 준비 완료');

      this._bgRemovalCache = { model, processor, transformers };
      this.bgRemovalLoadProgress = 100;
      return this._bgRemovalCache;
    } catch (e) {
      console.error('[RMBG] 모델 로드 실패:', e);
      console.error('[RMBG] 에러 상세:', {
        name: e && e.name,
        message: e && e.message,
        stack: e && e.stack
      });
      let userMsg = '배경 제거 모델 로드에 실패했습니다.';
      if (e && e.message) {
        if (e.message.includes('fetch') || e.message.includes('Failed to fetch')) {
          userMsg += ' (네트워크 오류 — CDN 접근 가능 여부 확인)';
        } else if (e.message.includes('CORS')) {
          userMsg += ' (CORS 오류)';
        } else {
          userMsg += ` (${e.message.slice(0, 80)})`;
        }
      }
      toast.error(userMsg, { autoClose: 8000 });
      throw e;
    } finally {
      this.bgRemovalModelLoading = false;
    }
  }

  // 단일 이미지 파일 → 배경 제거된 PNG/JPG File 반환
  // editpixel 검증된 구현 — 시그모이드 정규화 + 두 단계 캔버스 (마스크 → 스케일 → 합성)
  removeBackgroundFromFile = async (file) => {
    if (!file || !file.type || !file.type.startsWith('image/')) {
      return file; // 이미지 아니면 그대로
    }

    const { model, processor, transformers } = await this.loadBgRemovalPipeline();
    const { RawImage } = transformers;

    // 1) 원본 이미지 로드 — RawImage(전처리용) + HTMLImage(캔버스 그리기용)
    const fileUrl = URL.createObjectURL(file);
    let image, htmlImg;
    try {
      image = await RawImage.fromURL(fileUrl);
      htmlImg = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = fileUrl;
      });
    } finally {
      URL.revokeObjectURL(fileUrl);
    }

    // 2) 전처리 → 모델 추론
    const { pixel_values } = await processor(image);
    const result = await model({ input: pixel_values });

    // 3) 출력 텐서 추출 → squeeze로 배치/채널 차원 제거
    const outputTensor = result.output || result.logits || Object.values(result)[0];
    if (!outputTensor) throw new Error('모델 출력 텐서를 찾을 수 없습니다');
    const mask = outputTensor.squeeze();
    const rawData = mask.data;
    const maskH = mask.dims[0];
    const maskW = mask.dims[1];

    // 4) ★★★ 핵심: 마스크 값 정규화 ★★★
    // RMBG-1.4는 raw logits을 반환할 수 있어 sigmoid 적용이 필수
    // 값 범위 검사 후 logits이면 sigmoid, 아니면 클리핑만
    const uint8Mask = new Uint8Array(rawData.length);
    let min = Infinity, max = -Infinity;
    for (let i = 0; i < rawData.length; i++) {
      if (rawData[i] < min) min = rawData[i];
      if (rawData[i] > max) max = rawData[i];
    }
    console.log('[RMBG] 마스크 값 범위:', { min, max, useSigmoid: (min < -2.0 || max > 2.0) });

    if (min < -2.0 || max > 2.0) {
      // raw logits → sigmoid
      for (let i = 0; i < rawData.length; i++) {
        uint8Mask[i] = Math.round((1 / (1 + Math.exp(-rawData[i]))) * 255);
      }
    } else {
      // 이미 [0, 1] 범위 → 클리핑만
      for (let i = 0; i < rawData.length; i++) {
        uint8Mask[i] = Math.round(Math.max(0, Math.min(1, rawData[i])) * 255);
      }
    }

    // 5) 마스크 캔버스 생성 (모델 출력 크기)
    const maskCanvas = document.createElement('canvas');
    maskCanvas.width = maskW;
    maskCanvas.height = maskH;
    const maskCtx = maskCanvas.getContext('2d');
    const maskImgData = maskCtx.createImageData(maskW, maskH);
    for (let i = 0; i < uint8Mask.length; i++) {
      maskImgData.data[i * 4]     = uint8Mask[i];
      maskImgData.data[i * 4 + 1] = uint8Mask[i];
      maskImgData.data[i * 4 + 2] = uint8Mask[i];
      maskImgData.data[i * 4 + 3] = 255;
    }
    maskCtx.putImageData(maskImgData, 0, 0);

    // 6) 마스크를 원본 크기로 스케일 (drawImage가 부드러운 interpolation 적용)
    const w = htmlImg.naturalWidth;
    const h = htmlImg.naturalHeight;
    const scaledMask = document.createElement('canvas');
    scaledMask.width = w;
    scaledMask.height = h;
    const scaledCtx = scaledMask.getContext('2d');
    scaledCtx.drawImage(maskCanvas, 0, 0, maskW, maskH, 0, 0, w, h);
    const scaledData = scaledCtx.getImageData(0, 0, w, h).data;

    // 7) 최종 합성 캔버스에 원본 그리기
    const offscreen = document.createElement('canvas');
    offscreen.width = w;
    offscreen.height = h;
    const ctx = offscreen.getContext('2d');
    ctx.drawImage(htmlImg, 0, 0);

    // 8) 마스크를 흰 배경에 알파 블렌딩으로 합성 (cafe24/이미지 뷰어 호환)
    // 스케일된 마스크의 R 채널이 마스크 값
    const finalData = ctx.getImageData(0, 0, w, h);
    for (let i = 0; i < finalData.data.length; i += 4) {
      const a = scaledData[i] / 255; // 0~1
      const r = finalData.data[i];
      const g = finalData.data[i + 1];
      const b = finalData.data[i + 2];
      finalData.data[i]     = Math.round(r * a + 255 * (1 - a));
      finalData.data[i + 1] = Math.round(g * a + 255 * (1 - a));
      finalData.data[i + 2] = Math.round(b * a + 255 * (1 - a));
      finalData.data[i + 3] = 255; // 항상 불투명
    }
    ctx.putImageData(finalData, 0, 0);

    // 9) 원본 포맷 유지 — JPEG → JPEG, 그 외 → PNG
    const isJpeg = file.type === 'image/jpeg' || file.type === 'image/jpg';
    const outType = isJpeg ? 'image/jpeg' : 'image/png';
    const outExt = isJpeg ? 'jpg' : 'png';
    const quality = isJpeg ? 0.92 : undefined;

    const blob = await new Promise((resolve, reject) => {
      offscreen.toBlob(
        (b) => b ? resolve(b) : reject(new Error('canvas toBlob 실패')),
        outType,
        quality
      );
    });

    const baseName = (file.name || 'image').replace(/\.[^.]+$/, '');
    return new File([blob], `${baseName}_nobg.${outExt}`, { type: outType });
  }

  // 배경 제거 토글
  @action
  toggleBgRemoval = async () => {
    const next = !this.bgRemovalEnabled;
    this.bgRemovalEnabled = next;
    // 켜는 순간 모델을 미리 워밍업 (선택)
    if (next && !this._bgRemovalCache.model && !this.bgRemovalModelLoading) {
      try { await this.loadBgRemovalPipeline(); } catch (e) {}
    }
  }


  // getMediaType = (file) => {
  //   let type;
  //   if(file.type.indexOf('image/') > -1) {
  //     type = 'image';
  //   }
  //   else if(file.type.indexOf('video/') > -1) {
  //     type = 'video';
  //   }
  //   return type;
  // };

  getMediaType = async (file) => {
    let type;

    if (file.type.startsWith('image/')) {
      if (file.type === 'image/gif') {
        const isAnimated = await this.isAnimatedGif(file);
        type = isAnimated ? 'animated-gif' : 'image';
      } else if (file.type === 'image/webp') {
        // WebP도 애니메이션인지 구분 가능하게 하려면 isAnimatedWebp 추가 가능
        type = 'webp';
      } else {
        type = 'image';
      }
    } else if (file.type.startsWith('video/')) {
      type = 'video';
    }

    return type;
  };

  isAnimatedGif = async (file) => {
    const buffer = await file.arrayBuffer();
    const byteArray = new Uint8Array(buffer);

    let frames = 0;

    for (let i = 0; i < byteArray.length - 9; i++) {
      // Graphic Control Extension: 0x21, 0xF9
      if (
          byteArray[i] === 0x21 &&
          byteArray[i + 1] === 0xF9 &&
          byteArray[i + 2] === 0x04
      ) {
        frames++;
        if (frames > 1) {
          return true; // 두 개 이상의 프레임 => 애니메이션
        }
      }
    }

    return false;
  };


  convertWebp = async (imgSrc, cb) => {
    let imgToWebpBlob = await srcToWebP(imgSrc, { quality: imgOptimizationQuality*100 });
    // let blobTowebp = await webpConverterBrowser.blobToWebP(imgToWebpBlob, { quality: 100 });
    // console.log(blobTowebp);
    // let bufferToWebpBlob = await webpConverterBrowser.arrayBufferToWebP('./img/goods/sample01.jpg', { quality: 100 });
    let webpBlobSrc = URL.createObjectURL(imgToWebpBlob);
    let tempFile = new File([imgToWebpBlob], 'image_file.webp', { type: imgToWebpBlob.type });
    cb(webpBlobSrc, tempFile);
  };

  uploadFileToCafe24 = async (file, fetchHeader) => {
    const formData = new FormData();
    formData.append("file", file);

    let response;
    try {
      response = await fetch(process.env.NODE_ENV === "development" ? 'https://orpapi.onreview.co.kr/api/upload' : 'https://orpapi.onreview.co.kr/api/upload', {
        method: 'POST',
        body: formData,
        headers: fetchHeader
      });
    } catch (e) {
      throw new Error(`업로드 서버 연결 실패: ${e.message}`);
    }

    if (!response.ok) {
      throw new Error(`업로드 서버 오류 (HTTP ${response.status})`);
    }

    let data;
    try {
      data = await response.json();
    } catch (e) {
      throw new Error('업로드 응답을 읽을 수 없습니다.');
    }

    if (!Array.isArray(data) || !data[0] || !data[0].fullPath) {
      console.error('업로드 응답 비정상:', data);
      throw new Error('업로드 응답이 올바르지 않습니다.');
    }

    const toUploadParams = {
      store_id: this.store._id,
      imagesUrls: [data[0].fullPath]
    };

    return await new Promise((resolve, reject) => {
      this.props.cafe24UploadFiles(toUploadParams, function(res) {
        // GraphQL errors
        if (res && res.errors && res.errors.length > 0) {
          return reject(new Error(res.errors[0].message || '카페24 파일 업로드에 실패했습니다.'));
        }
        // Backend 반환: {error: {code, message}}
        if (res && res.error && res.error.message) {
          return reject(new Error(`카페24: ${res.error.message}`));
        }
        // Cafe24 API 에러 응답 (errors 배열 또는 message 필드)
        if (res && Array.isArray(res.errors) && res.errors[0]) {
          const e0 = res.errors[0];
          return reject(new Error(`카페24: ${e0.message || e0.code || '파일 업로드 실패'}`));
        }
        if (res && res.message && !res.files) {
          return reject(new Error(`카페24: ${res.message}`));
        }
        // 정상 응답
        if (res && Array.isArray(res.files) && res.files[0]) {
          const f = res.files[0];
          const url = f.url || f.path;
          if (!url || !/^https?:\/\//.test(url)) {
            console.error('카페24 반환 URL 비정상:', f);
            return reject(new Error('카페24가 반환한 이미지 URL이 유효하지 않습니다.'));
          }
          return resolve({ ...f, url });
        }
        // 기타 (빈 응답 등)
        console.error('카페24 응답 비정상:', res);
        reject(new Error('카페24 업로드 응답이 비어 있거나 형식이 올바르지 않습니다.'));
      });
    });
  };

  uploadBase64Image = async (base64Image) => {
    return await new Promise((resolve, reject) => {
      this.props.base64UploadImages({
        store_id: this.teamUser.selStore_id,
        base64Imgs: [{ image: base64Image }]
      }, function(res) {
        if (res && res.errors && res.errors.length > 0) {
          reject(new Error(res.errors[0].message));
        } else if (res && res.images && res.images[0]) {
          resolve(res.images[0]);
        } else {
          resolve(null);
        }
      });
    });
  };

  readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('파일을 읽는 중 오류가 발생했습니다.'));
      reader.readAsDataURL(file);
    });
  };

  loadImageElement = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('이미지를 불러오는 중 오류가 발생했습니다.'));
      img.src = src;
    });
  };

  loadImageFromBlob = (blob) => {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = (error) => {
        URL.revokeObjectURL(url);
        reject(error);
      };
      img.src = url;
    });
  };

  generateThumbnailDataUrl = (img) => {
    const maxSize = 500;
    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
    const width = Math.max(1, Math.round(img.width * scale));
    const height = Math.max(1, Math.round(img.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;              // 보간 활성화
    ctx.imageSmoothingQuality = 'high';            // 고품질 보간

    ctx.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL('image/jpeg', 0.92);   // 1 대신 0.9~0.95 정도 권장
  };

  addThumbnailRecord = (name, url) => {
    if (!this.newReview.thumbs) {
      this.newReview.thumbs = [];
    }
    this.newReview.thumbs.push({
      name: name || 'thumbnail',
      url
    });
  };

  addThumbnailFromImageElement = async (img, options = {}) => {
    const { fallbackUrl, name } = options;
    try {
      const thumbDataUrl = this.generateThumbnailDataUrl(img);
      const uploadedThumb = await this.uploadBase64Image(thumbDataUrl);
      if (uploadedThumb && uploadedThumb.path) {
        this.addThumbnailRecord(name, uploadedThumb.path);
      } else if (fallbackUrl) {
        this.addThumbnailRecord(name, fallbackUrl);
      }
    } catch (error) {
      console.error('썸네일 생성 실패:', error);
      if (fallbackUrl) {
        this.addThumbnailRecord(name, fallbackUrl);
      }
    }
  };

  addThumbnailFromFile = async (file, fallbackUrl, name) => {
    try {
      const dataUrl = await this.readFileAsDataURL(file);
      const img = await this.loadImageElement(dataUrl);
      await this.addThumbnailFromImageElement(img, { fallbackUrl, name });
    } catch (error) {
      console.error('파일 기반 썸네일 생성 실패:', error);
      if (fallbackUrl) {
        this.addThumbnailRecord(name, fallbackUrl);
      }
    }
  };

  addThumbnailFromBlob = async (blob, fallbackUrl, name) => {
    try {
      const img = await this.loadImageFromBlob(blob);
      await this.addThumbnailFromImageElement(img, { fallbackUrl, name });
    } catch (error) {
      console.error('블롭 기반 썸네일 생성 실패:', error);
      if (fallbackUrl) {
        this.addThumbnailRecord(name, fallbackUrl);
      }
    }
  };

  onFileUpload = async (event, overrideFiles) => {
    if (this.blockExpired()) return;
    const files = Array.isArray(overrideFiles)
      ? overrideFiles
      : Array.from(event && event.target && event.target.files ? event.target.files : []);

    if (!files || files.length === 0) {
      return;
    }

    this.isUploading = true;

    // 배경 제거 옵션이 켜져 있으면 이미지에 대해 사전 처리
    let processedFiles = files;
    if (this.bgRemovalEnabled) {
      try {
        const imageFiles = files.filter(f => f && f.type && f.type.startsWith('image/'));
        if (imageFiles.length > 0) {
          this.bgRemovalProcessing = true;
          this.bgRemovalProgress = { current: 0, total: imageFiles.length, fileName: '' };

          const result = [];
          for (const file of files) {
            if (file && file.type && file.type.startsWith('image/')) {
              this.bgRemovalProgress = {
                current: this.bgRemovalProgress.current + 1,
                total: imageFiles.length,
                fileName: file.name
              };
              try {
                const processed = await this.removeBackgroundFromFile(file);
                result.push(processed);
              } catch (e) {
                console.error('배경 제거 실패, 원본 사용:', file.name, e);
                toast.warning(`${file.name}: 배경 제거 실패, 원본을 업로드합니다.`);
                result.push(file);
              }
            } else {
              // 동영상 등은 원본 그대로
              result.push(file);
            }
          }
          processedFiles = result;
          toast.success(`${imageFiles.length}개 이미지의 배경을 제거했습니다.`);
        }
      } catch (e) {
        console.error('배경 제거 단계 오류:', e);
      } finally {
        this.bgRemovalProcessing = false;
        this.bgRemovalProgress = { current: 0, total: 0, fileName: '' };
      }
    }

    try {
      for (const file of processedFiles) {
        try {
          await this.uploadSingleFile(file);
        } catch (error) {
          console.error('파일 업로드 실패:', error);
          toast.error(`"${file && file.name ? file.name : '파일'}" 업로드 실패: ${(error && error.message) || '알 수 없는 오류'}`);
        }
      }
    } finally {
      this.isUploading = false;
      // 같은 파일을 다시 선택했을 때 이벤트가 다시 발생하도록 input 값 초기화
      if (event && event.target) {
        try { event.target.value = ''; } catch (e) {}
      }
    }
  };

  uploadSingleFile = async (file) => {
    if (!file) {
      return;
    }

    const allowedExtensions = ["image/", "video/mp4", "video/quicktime"];
    const fileType = file.type || '';

    if (!allowedExtensions.some(ext => fileType.startsWith(ext))) {
      alert("이미지 파일 또는 MP4, MOV 형식의 영상만 선택 가능합니다.");
      return;
    }

    const fetchHeader = process.env.NODE_ENV === "development" ? {'X-Target-Server': ''} : {};
    const mediaType = await this.getMediaType(file);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const maxWidth = 2048;
    const maxHeight = 2048;
    const orgFileName = file.name.split(".")[0];
    const chgFileName = util.generateUniqueFilename();
    const extension = file.name.split('.').pop();
    const renamedFile = new File([file], chgFileName + '.' + extension, {
      type: file.type
    });

    console.log("mediaType", mediaType)
    if (mediaType === 'animated-gif' || mediaType === 'webp') {
      try {
        const uploaded = await this.uploadFileToCafe24(renamedFile, fetchHeader);
        if (uploaded) {
          this.newReview.images.push({ name: orgFileName + ".webp", url: uploaded.url });
          // animated-gif일 때는 썸네일을 생성하지 않고 업로드된 이미지를 그대로 사용
          this.addThumbnailRecord(`${orgFileName}_thumb`, uploaded.url);
        }
      } catch (error) {
        console.error('GIF/WEBP 업로드 실패:', error);
        toast.error(`"${file.name}" 업로드 실패: ${error.message || '알 수 없는 오류'}`);
      }
      return;
    }

    if (mediaType === 'image') {
      if (file.size / 1000000 > 60) {
        alert('파일 용량이 60MB 이하만 등록이 가능합니다.');
        return;
      }

      try {
        const dataUrl = await this.readFileAsDataURL(file);
        const imgObj = await this.loadImageElement(dataUrl);

        let width = imgObj.width;
        let height = imgObj.height;

        if (maxWidth > 0 && maxHeight > 0) {
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
        }

        if (imgOptimizationType === 'webp') {
          await new Promise(resolve => {
            this.convertWebp(imgObj.src, async () => {
              try {
                const uploaded = await this.uploadFileToCafe24(renamedFile, fetchHeader);
                if (uploaded) {
                  this.newReview.images.push({ name: orgFileName + ".webp", url: uploaded.url });
                  await this.addThumbnailFromImageElement(imgObj, { fallbackUrl: uploaded.url, name: `${orgFileName}_thumb` });
                }
              } catch (error) {
                console.error('이미지 업로드 실패:', error);
                toast.error(`"${file.name}" 업로드 실패: ${error.message || '알 수 없는 오류'}`);
              }
              resolve();
            });
          });
        } else if (imgOptimizationType === 'canvas') {
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(imgObj, 0, 0, width, height);
          const compressedDataUrl = canvas.toDataURL('image/jpeg', imgOptimizationQuality);

          try {
            const uploadedImage = await this.uploadBase64Image(compressedDataUrl);
            if (uploadedImage) {
              this.newReview.images.push({ url: uploadedImage.path, name: file.name });
              await this.addThumbnailFromImageElement(imgObj, { fallbackUrl: uploadedImage.path, name: `${orgFileName}_thumb` });
            } else {
              toast.error(`"${file.name}" 업로드 실패: 서버 응답이 비어 있습니다.`);
            }
          } catch (error) {
            console.error('BASE64 업로드 실패:', error);
            toast.error(`"${file.name}" 업로드 실패: ${error.message || '알 수 없는 오류'}`);
          }
        } else {
          try {
            const uploaded = await this.uploadFileToCafe24(renamedFile, fetchHeader);
            if (uploaded) {
              this.newReview.images.push({ name: orgFileName + ".webp", url: uploaded.url });
              await this.addThumbnailFromImageElement(imgObj, { fallbackUrl: uploaded.url, name: `${orgFileName}_thumb` });
            }
          } catch (error) {
            console.error('이미지 업로드 실패:', error);
            toast.error(`"${file.name}" 업로드 실패: ${error.message || '알 수 없는 오류'}`);
          }
        }
      } catch (error) {
        console.error('이미지 처리 중 오류:', error);
        toast.error(`"${file.name}" 이미지 처리 오류: ${error.message || '알 수 없는 오류'}`);
      }
      return;
    }

    if (mediaType === 'video') {
      try {
        const webpFile = await convertVideoToAnimatedWebp(file, chgFileName);

        const uploaded = await this.uploadFileToCafe24(webpFile, fetchHeader);
        if (uploaded) {
          // 썸네일 이미지를 생성하지 않고, uploaded.url을 바로 썸네일로 사용
          this.newReview.images.push({ name: "on_wp_mov_" + chgFileName + ".webp", url: uploaded.url });
          this.newReview.thumbs.push({ name: "on_wp_mov_" + chgFileName + ".webp", url: uploaded.url });
        }
      } catch (error) {
        console.error('WebP 업로드 실패:', error);
        toast.error(`"${file.name}" 동영상 업로드 실패: ${error.message || '알 수 없는 오류'}`);
      }
    }
  };

  onClickMediaRemove = async (item, i, mediaType) => {
    if (this.blockExpired()) return;
    let params =  {
      mediaType: mediaType,
      image_id: item.cloudflare_id
    }
    this.newReview[mediaType].splice(i, 1);
    if (mediaType === 'images' && this.newReview.thumbs && this.newReview.thumbs.length > i) {
      this.newReview.thumbs.splice(i, 1);
    }
    await this.props.removeMedia(params);
  };

  updateReview = async (product) => {
    if (this.blockExpired()) return;

    if(!this.isUse) {
      toast.error('유료 플랜 전용 기능입니다. 결제 페이지에서 플랜을 활성화해주세요.');
      return false;
    }

    let _this = this;
    _this.newReview.product_id = product._id;
    _this.newReview.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;
    _this.newReview.platformProductId = product.platformProductId;
    _this.newReview.orderProductName = product.productName;
    if(!_this.newReview.writerName || _this.newReview.writerName === '') {
      alert('작성자를 입력해 주세요.');
      return false;
    }
    else if(!_this.newReview.contents || _this.newReview.contents === '') {
      alert('리뷰 내용을 입력해 주세요.');
      return false;
    }
    _this.newReview.goodsPt = parseInt(_this.newReview.goodsPt);
    _this.newReview.deliveryPt = parseInt(_this.newReview.deliveryPt);

    // 설문 답변 추가
    if (Object.keys(_this.surveyAnswers).length > 0 && _this.productSurvey.length > 0) {
      _this.newReview.surveyAnswers = [];

      // productSurvey에서 질문 정보를 찾아서 매핑
      for (let itemId in _this.surveyAnswers) {
        const answer = _this.surveyAnswers[itemId];
        if (answer && (Array.isArray(answer) ? answer.length > 0 : true)) {
          // 질문 정보 찾기
          let questionInfo = null;
          for (let group of _this.productSurvey) {
            if (group.item_ids && group.item_ids.length > 0) {
              const found = group.item_ids.find(function(item) {
                return item._id === itemId;
              });
              if (found) {
                questionInfo = found;
                break;
              }
            }
          }

          if (questionInfo) {
            _this.newReview.surveyAnswers.push({
              questionId: itemId,
              questionName: questionInfo.name,
              questionType: questionInfo.options && questionInfo.options.questionType ? questionInfo.options.questionType : 'text',
              answer: Array.isArray(answer) ? answer.join(', ') : answer
            });
          }
        }
      }
    }

    this.props.updateReview(_this.newReview, function(res) {
      _this.modals.isWriteForm = false;
      if(res && res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else if(!res || !res.data) {
        // 서버 에러(HTTP 에러, GraphQL 에러 등)로 정상 응답 형태가 아닌 경우
        toast("리뷰가 정상적으로 작성이 되지 않았습니다.");
      }
      else {
        if(res.data.message) {
          if(res.data.message.indexOf("maximum size of") > -1) {
            toast("카페24의 리뷰 게시판의 파일첨부기능 및 첨부파일용량제한을 확인해 주세요.");
          }
          else {
            toast("리뷰가 정상적으로 작성이 되지 않았습니다.");
          }

        }
        else {
          toast("리뷰가 작성되었습니다.")
          // 리뷰 작성 성공 시 상품 목록을 다시 불러와 '리뷰 현황'(scoreInfo)을 갱신
          _this.getProductList();
        }

        // _this.newReplyContents = {
        //   grade: null,
        //   text: ''
        // };
      }
      _this.initNewReview();

    });
  }

  genAIReviewAnalysis = async (data) => {
    if (this.blockExpired()) return;
    console.log(data)
    let params = {
      store_id: data.product.store_id,
      product_id: data.product._id
    }
    this.props.genAIReviewAnalysis(params, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        console.log(res);

      }
    });
  };

  // setDropdown = async (target, value) => {
  //   if(target === 'isCreatedAt') {
  //     if(value === 'tomorrow') {
  //       this.newReview.createdAt = moment().add(1, 'days').format('yyyy-MM-DD');
  //     }
  //     else if(value === 'input') {
  //       this.isShowCalendar.createdAt = true;
  //     }
  //     else {
  //       this.newReview.createdAt = moment().format('yyyy-MM-DD');
  //     }
  //   }
  // };

  getProductList = async() => {
    Storage.set('limitReviewWriteList', this.listParams.limit);
    if(this.listParams.store_id) {
      this.listParams.searchParams = this.searchParams;
      this.list = await this.props.getProductList(this.listParams);
      this.isLoading = false;

      // 페이지 가이드 — 첫 로드 후 1회 자동 시작(미열람 시). 상품 행 렌더 후 타깃 존재하도록 약간 지연.
      if (!this._guideTried) {
        this._guideTried = true;
        setTimeout(() => guideManager.maybeAutoStart('reviewWrite', { storeId: this.store && this.store._id }), 500);
      }
    }
    else {
      //console.log('null store_id');
    }
  };

  search = async() => {
    let urlParams = new URLSearchParams();
    for(let key in this.searchParams) {
      if(key !== 'store_id' && key !== 'teamUserId' && key !== 'limit' && this.searchParams[key])
        urlParams.set(key, this.searchParams[key]);
    }
    window.location.search = urlParams.toString();
  };

  onChangeSearchValue = async (event) => {
    const { name, value, type } = event.target;
    if(type === 'checkbox') {
      if(value) {
        this.searchParams[name] = !JSON.parse(value);
      }
      else {
        this.searchParams[name] = true;
      }
    }
    else {
      this.searchParams[name] = value;
    }
  };




  // setProductSync = async (event) => {
  //   let _this = this;
  //   if(! await this.checkPaidUser()) return false;
  //   _this.isLoading = true;
  //   let data = {
  //     store_id: _this.teamUser.selStore_id,
  //     shopNo: _this.teamUser.selShopNo,
  //     teamUser_id: _this.teamUser.id,
  //     // limit: 5,
  //     // page: 1
  //   }
  //
  //   _this.props.setProductSync(data, function(res) {
  //     if(res.errors && res.errors.length > 0) {
  //       toast(res.errors[0].message);
  //     }
  //     else {
  //       setTimeout(() => {
  //         toast(res.data.productCount + "상품정보 업데이트 완료 되었습니다.");
  //         _this.getProductList();
  //       }, 3000);
  //     }
  //
  //   });
  // };

  updateProductReplay = async (item) => {
    if (this.blockExpired()) return;
    let _this = this;
    console.log(item)
    let params = {
      store_id: this.store._id,
      product_id: item._id,
    }
    if(item.vr_productReply._id) {
      params.id = item.vr_productReply._id;
    }
    if(item.vr_productReply.type) {
      params.type = item.vr_productReply.type;
    }
    if(item.vr_productReply.tone) {
      params.tone = item.vr_productReply.tone;
    }
    console.log(params)


    _this.props.updateProductReplay(params, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast("업데이트 완료 되었습니다.")
      }
    });
  }

  modalToggle = function(target, data) {
    let _this = this;
    if(!target) {
      for( var i in this.modals) {
        if(i.indexOf('is') === 0) {
          this.modals[i] = false;
        }
      }
    }
    else {
      this.modals[target] = !this.modals[target];
    }
    if(data) {
      if(target === 'isMakeWidgetModal' && data) {
        this.modals.widgetData.product = data;
        let params = {
          store_id: data.store_id,
          product_id: data._id,
        }
        this.props.getAnalysisList(params, function(res) {
          if(res.errors && res.errors.length > 0) {
            toast(res.errors[0].message);
          }
          else {
            _this.modals.widgetData.aiList = res;
            _this.showPreviewWidget(_this.modals.widgetData.aiList.docs[0]);
          }
        });

      }
      else {
        this.modals.data = data;
        // 리뷰 작성 모달 열 때 상품에 맞는 설문 + 옵션 로드
        if (target === 'isWriteForm' && data) {
          this.loadSurveyForProduct(data);
          this.loadProductOptions(data);
        }
      }

    }
  };

  // 상품 옵션 조회 (cafe24) — 옵션이 있는 상품이면 선택용 드롭다운을 띄울 수 있게 정의를 구성
  @action
  loadProductOptions = (product) => {
    let _this = this;
    this.productOptionDefs = [];
    this.selectedOptions = {};
    if (this.newReview) this.newReview.orderProductOptions = '';
    if (!product || !product.platformProductId) return;
    this.optionsLoading = true;
    this.props.getCafe24ProductOptions({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      platformProductId: product.platformProductId,
    }, action(function (res) {
      _this.optionsLoading = false;
      if (!res || (res.errors && res.errors.length > 0)) return;   // 미배포/에러 시 옵션 없이 진행
      const root = res.data ? res.data : res;
      // cafe24 응답은 { option: { has_option, options:[...] } } 처럼 단수 'option' 키로 감싸져 옴
      const block = (root && (root.option || root.options)) || {};
      const hasOption = block.has_option === 'T' || block.has_option === true;
      const list = Array.isArray(block.options) ? block.options : [];
      if (!hasOption || list.length === 0) return;
      _this.productOptionDefs = list.map(function (o) {
        const values = (Array.isArray(o.option_value) ? o.option_value : [])
          .map(function (v) { return (v && v.option_text != null) ? v.option_text : (typeof v === 'string' ? v : ''); })
          .filter(function (t) { return t !== ''; });
        return { name: o.option_name || '', required: o.required_option === 'T', values: values };
      }).filter(function (d) { return d.name && d.values.length > 0; });
    }));
  };

  // 옵션 선택 변경 → orderProductOptions 를 "옵션명: 값 / 옵션명: 값" 형식으로 재구성
  @action
  onChangeOption = (name, value) => {
    const next = Object.assign({}, this.selectedOptions);
    if (value === '' || value == null) { delete next[name]; }
    else { next[name] = value; }
    this.selectedOptions = next;
    this.newReview.orderProductOptions = this.productOptionDefs
      .map(function (d) { return next[d.name] ? (d.name + ': ' + next[d.name]) : null; })
      .filter(Boolean)
      .join(' / ');
  };

  showPreviewWidget = function(data) {
    console.log(data);
    this.widgetUrl = "https://onreple-skin-widget.pages.dev/widget/ai/basic.html?s_id=" + data.store_id + "&a_id=" + data._id+ "&p_id=" + data.product_id;
  }

  checkPaidUser = async () => {
    if(!this.teamUser.hasReviewWriteAddon) {
      toast.error('리뷰 부스터 추가 옵션 결제가 필요합니다. 결제 페이지에서 옵션을 활성화해주세요.');
    }
    return this.teamUser.hasReviewWriteAddon;
  }

  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
                { startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page="+(startNum-1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
                {rendering()}
                { endNum !== totalPages  ? <li className="btn-page-next"><a href={urlParams + "&page="+(startNum+10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
                { curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + "&page="+totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }

    }

    function AvgScore(props) {
      let avg = 0;
      let scoreInfo = props.scoreInfo;
      if(scoreInfo.reviewCount > 0) {
        avg = parseFloat((scoreInfo.goodsPtSum / scoreInfo.reviewCount / 20).toFixed(2));
      }
      else {
        avg = 0;
      }
      return avg;
    }

    // 리디자인: 헬퍼 변수
    const hasActiveFilters = !!(this.searchParams.keyword || this.searchParams.category || this.searchParams.overReviewCount);
    const categoryNameById = (id) => {
      if (!id || !this.categories) return '';
      const c = this.categories.find(x => String(x.category_no) === String(id));
      return c ? c.category_name : '';
    };
    const reviewCountLabel = {
      '1': '리뷰 1개 이상', '5': '리뷰 5개 이상', '10': '리뷰 10개 이상',
      '30': '리뷰 30개 이상', '50': '리뷰 50개 이상', '100': '리뷰 100개 이상',
      '500': '리뷰 500개 이상', '1000': '리뷰 1000개 이상'
    };

    return (
        <div className="main-content reviewwrite-redesign">
          <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16}}>
            <PageTitle />
            <HelpButton tourKey="reviewWrite" />
          </div>
          {this.isExpired && (
            <div style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              background: '#FEF2F2', border: '1px solid #FECACA', color: '#B91C1C',
              padding: '10px 14px', borderRadius: '8px', margin: '0 0 12px', fontSize: '13px'
            }}>
              <FeatherIcon icon="alert-triangle" size="16" />
              <span>서비스 사용 기간이 만료되어 리뷰 작성 기능(작성·사진 추가/삭제·AI 등)을 이용할 수 없습니다.</span>
              <a href="/inAppOrder" style={{
                marginLeft: 'auto', background: '#B91C1C', color: '#fff',
                padding: '5px 12px', borderRadius: '6px', fontSize: '12px', whiteSpace: 'nowrap'
              }}>연장하기</a>
            </div>
          )}

          {/* === 1단계: Alert 배너 — 동의 체크 후 닫기 (sessionStorage 정책) === */}
          {this.showWarning && (
            <div className="rw-alert-banner" role="alert">
              <div className="rw-alert-icon" aria-hidden="true">
                <FeatherIcon icon="alert-triangle" size="18" />
              </div>
              <div className="rw-alert-body">
                <div className="rw-alert-text">
                  <strong>유의사항</strong>
                  <p>해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 있습니다. 작성된 리뷰로 인해 발생하는 모든 법적 분쟁의 책임은 작성자에게 귀속됩니다.</p>
                </div>
                <div className="rw-alert-actions">
                  <label className="rw-alert-agree" htmlFor="rw-warning-agree">
                    <input
                      id="rw-warning-agree"
                      type="checkbox"
                      checked={this.warningAgreed}
                      onChange={() => this.toggleWarningAgree()}
                      aria-describedby="rw-warning-text"
                    />
                    <span className="rw-alert-agree-box" aria-hidden="true">
                      {this.warningAgreed && <FeatherIcon icon="check" size="11" />}
                    </span>
                    <span className="rw-alert-agree-label">위 유의사항에 동의합니다</span>
                  </label>
                  <button type="button"
                          className="rw-alert-confirm-btn"
                          disabled={!this.warningAgreed}
                          onClick={() => this.dismissWarning()}
                          aria-label={this.warningAgreed ? '동의하고 닫기' : '동의 후 닫기 가능'}>
                    <FeatherIcon icon="check" size="13" aria-hidden="true" />
                    동의하고 닫기
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* === 1단계: 인라인 필터 바 === */}
          <div className="rw-filter-bar">
            <div className="rw-filter-row">
              <FormSelect name="category"
                          value={this.searchParams.category}
                          onChange={(e) => this.onChangeSearchValue(e)}
                          className="rw-filter-category"
                          aria-label="카테고리 필터">
                <option value="">전체 카테고리</option>
                {this.categories && this.categories.map((item, i) => (
                  <option key={i} value={item.category_no}>{item.category_name}</option>
                ))}
              </FormSelect>

              <div className="rw-filter-search">
                <FeatherIcon icon="search" size="14" aria-hidden="true" className="rw-filter-search-icon" />
                <input
                  type="text"
                  name="keyword"
                  placeholder="상품명 검색..."
                  value={this.searchParams.keyword}
                  onChange={(e) => this.onChangeSearchValue(e)}
                  onKeyDown={(e) => { if (e.keyCode === 13) this.search(); }}
                  className="rw-filter-search-input"
                  aria-label="상품명 검색"
                />
                {this.searchParams.keyword && (
                  <button type="button" className="rw-filter-search-clear"
                          onClick={() => this.clearSearchFilter('keyword')}
                          aria-label="검색어 지우기">
                    <FeatherIcon icon="x" size="12" />
                  </button>
                )}
              </div>

              <FormSelect name="overReviewCount"
                          value={this.searchParams.overReviewCount}
                          onChange={(e) => this.onChangeSearchValue(e)}
                          className="rw-filter-count"
                          aria-label="리뷰 수 필터">
                <option value="">리뷰 수 전체</option>
                <option value="1">1개 이상</option>
                <option value="5">5개 이상</option>
                <option value="10">10개 이상</option>
                <option value="30">30개 이상</option>
                <option value="50">50개 이상</option>
                <option value="100">100개 이상</option>
                <option value="500">500개 이상</option>
                <option value="1000">1000개 이상</option>
              </FormSelect>

              <button type="button" className="rw-filter-search-btn"
                      onClick={() => this.search()}
                      aria-label="검색">
                <FeatherIcon icon="search" size="13" aria-hidden="true" />
                검색
              </button>
            </div>

            {/* 활성 필터 칩 */}
            {hasActiveFilters && (
              <div className="rw-filter-chips">
                <span className="rw-chips-label">
                  <FeatherIcon icon="filter" size="11" aria-hidden="true" />
                  활성 필터
                </span>
                {this.searchParams.category && (
                  <span className="rw-chip">
                    카테고리: <strong>{categoryNameById(this.searchParams.category)}</strong>
                    <button type="button" onClick={() => this.clearSearchFilter('category')} aria-label="카테고리 필터 해제">
                      <FeatherIcon icon="x" size="11" />
                    </button>
                  </span>
                )}
                {this.searchParams.keyword && (
                  <span className="rw-chip">
                    검색: <strong>{this.searchParams.keyword}</strong>
                    <button type="button" onClick={() => this.clearSearchFilter('keyword')} aria-label="검색어 필터 해제">
                      <FeatherIcon icon="x" size="11" />
                    </button>
                  </span>
                )}
                {this.searchParams.overReviewCount && (
                  <span className="rw-chip">
                    {reviewCountLabel[this.searchParams.overReviewCount]}
                    <button type="button" onClick={() => this.clearSearchFilter('overReviewCount')} aria-label="리뷰 수 필터 해제">
                      <FeatherIcon icon="x" size="11" />
                    </button>
                  </span>
                )}
                <button type="button" className="rw-chips-reset" onClick={() => this.resetSearchFilters()}>
                  전체 초기화
                </button>
              </div>
            )}
          </div>

          {/* === 검색 결과 카운트 + 페이지 사이즈 === */}
          <div className="rw-result-bar">
            <div className="rw-result-count">
              <FeatherIcon icon="package" size="14" aria-hidden="true" />
              검색결과 <strong>{(this.list.totalDocs || 0).toLocaleString()}</strong>개
            </div>
            <div className="rw-result-pagesize">
              <label htmlFor="rw-pagesize" className="rw-pagesize-label">페이지당</label>
              <select id="rw-pagesize"
                      name="limit"
                      value={this.listParams.limit}
                      onChange={(e) => {
                        this.listParams.limit = parseInt(e.target.value);
                        this.getProductList();
                      }}
                      className="rw-pagesize-select">
                <option value="20">20개</option>
                <option value="50">50개</option>
                <option value="100">100개</option>
              </select>
            </div>
          </div>

          {/* === 2단계: 상품 목록 테이블 리디자인 === */}
          <div className="rw-product-table-card">
            {this.list && this.list.docs && this.list.docs.length > 0 ? (
              <table className="rw-product-table">
                <colgroup>
                  <col style={{width: '88px'}}/>
                  <col />
                  <col style={{width: '24%'}}/>
                  <col style={{width: '14%'}}/>
                </colgroup>
                <thead>
                  <tr>
                    <th>이미지</th>
                    <th>상품 정보</th>
                    <th>리뷰 현황</th>
                    <th className="text-right">관리</th>
                  </tr>
                </thead>
                <tbody>
                  {this.list.docs.map((item, i) => {
                    const avg = item.scoreInfo && item.scoreInfo.reviewCount > 0
                      ? parseFloat((item.scoreInfo.goodsPtSum / item.scoreInfo.reviewCount / 20).toFixed(2))
                      : 0;
                    const reviewCount = item.scoreInfo ? item.scoreInfo.reviewCount : 0;
                    const _domain = this.teamUser.shop && this.teamUser.shop.primaryDomain ? this.teamUser.shop.primaryDomain : this.store.platformId + '.cafe24.com';
                    const _urlType = (this.teamUser.basicSettings && this.teamUser.basicSettings.productDetailUrlType) || 'easy';
                    const productUrl = _urlType === 'basic'
                      ? '//' + _domain + '/product/detail.html?product_no=' + item.platformProductId
                      : '//' + _domain + '/product/' + item.productName + '/' + item.platformProductId;
                    return (
                      <tr key={i} className="rw-product-row">
                        <td>
                          <a href={productUrl} target="_blank" rel="noopener noreferrer" className="rw-product-thumb">
                            <img src={item.images && item.images.s_1} alt={item.productName} />
                          </a>
                        </td>
                        <td>
                          <div className="rw-product-info">
                            <a href={productUrl} target="_blank" rel="noopener noreferrer" className="rw-product-name" title={item.productName}>
                              {item.productName}
                            </a>
                            <div className="rw-product-meta">
                              <span className="rw-product-code">상품번호 {item.platformProductId}</span>
                              <a href={"https://search.shopping.naver.com/search/all?query=" + encodeURI(item.productName)}
                                 target="_blank" rel="noopener noreferrer"
                                 className="rw-naver-link"
                                 onClick={(e) => e.stopPropagation()}>
                                <FeatherIcon icon="external-link" size="10" aria-hidden="true" />
                                네이버 검색
                              </a>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="rw-review-stats">
                            <div className="rw-review-count-wrap">
                              <span className="rw-review-count-badge">{reviewCount.toLocaleString()}</span>
                              <span className="rw-review-count-label">리뷰</span>
                            </div>
                            <div className="rw-review-rating">
                              <div className="rw-star-mini" aria-label={`평점 ${avg}점`}>
                                {[1,2,3,4,5].map(n => (
                                  <span key={n} className={`rw-star-mini-icon ${n <= Math.round(avg) ? 'is-filled' : ''}`}>★</span>
                                ))}
                              </div>
                              <span className="rw-rating-value">{avg.toFixed(1)}</span>
                            </div>
                          </div>
                        </td>
                        <td className="text-right">
                          <button type="button" className="rw-write-btn"
                                  disabled={!this.isUse || !this.warningAgreed}
                                  onClick={() => this.modalToggle('isWriteForm', item)}
                                  title={!this.warningAgreed ? '유의사항에 먼저 동의해 주세요' : (!this.isUse ? '유료회원 전용 기능입니다' : '')}
                                  aria-label={`${item.productName} 리뷰 작성`}>
                            <FeatherIcon icon="edit-3" size="13" aria-hidden="true" />
                            작성
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className="rw-empty">
                <div className="rw-empty-illust" aria-hidden="true">
                  <svg viewBox="0 0 120 120" width="100" height="100">
                    <circle cx="60" cy="60" r="56" fill="#F1F5F9" />
                    <circle cx="56" cy="56" r="22" fill="none" stroke="#94A3B8" strokeWidth="3"/>
                    <line x1="74" y1="74" x2="92" y2="92" stroke="#94A3B8" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </div>
                <h4 className="rw-empty-title">검색 결과가 없습니다</h4>
                <p className="rw-empty-desc">
                  {hasActiveFilters
                    ? '검색 조건에 맞는 상품이 없습니다. 필터를 변경하거나 초기화 해보세요.'
                    : '아직 등록된 상품이 없거나 데이터를 불러오는 중입니다.'}
                </p>
                {hasActiveFilters && (
                  <button type="button" className="rw-empty-btn" onClick={() => this.resetSearchFilters()}>
                    <FeatherIcon icon="x" size="13" aria-hidden="true" />
                    필터 초기화
                  </button>
                )}
              </div>
            )}
            <Pagination />
          </div>

          {/* === 3-8단계: 리뷰 작성 모달 통합 리디자인 === */}
          <Modal size="lg"
                 className="modal-review-write-form rw-modal-redesign"
                 open={this.modals.isWriteForm}
                 toggle={() => {}}
                 centered={true}>
            {/* 4단계: 모달 헤더 강화 - 상품 썸네일 + 상품명 */}
            <div className="rw-modal-header">
              <div className="rw-modal-header-info">
                {this.modals.data && this.modals.data.images && (
                  <div className="rw-modal-thumb">
                    <img src={this.modals.data.images.s_1} alt={this.modals.data.productName} />
                  </div>
                )}
                <div className="rw-modal-titles">
                  <div className="rw-modal-eyebrow">리뷰 작성</div>
                  <div className="rw-modal-title" title={this.modals.data && this.modals.data.productName}>
                    {this.modals.data ? this.modals.data.productName : '리뷰 작성'}
                  </div>
                </div>
              </div>
              <button type="button" className="rw-modal-close"
                      onClick={() => this.modals.isWriteForm = false}
                      aria-label="닫기">
                <FeatherIcon icon="x" size="18" />
              </button>
            </div>

            <ModalBody className="rw-modal-body">
              <div className="rw-modal-scroll">

                {/* === 4단계: 상품 정보 카드 === */}
                {this.modals.data && (
                  <section className="rw-section">
                    <div className="rw-section-title">
                      <FeatherIcon icon="package" size="14" aria-hidden="true" />
                      상품 정보
                    </div>
                    <div className="rw-product-card">
                      <div className="rw-product-card-img">
                        <img src={this.modals.data.images && this.modals.data.images.s_1} alt={this.modals.data.productName}/>
                      </div>
                      <div className="rw-product-card-meta">
                        <div className="rw-product-card-name">{this.modals.data.productName}</div>
                        <div className="rw-product-card-id">상품번호 {this.modals.data.platformProductId}</div>
                      </div>
                      <div className="rw-product-card-stats">
                        <div className="rw-product-card-stat">
                          <span className="rw-product-card-stat-label">리뷰수</span>
                          <strong>{this.modals.data.scoreInfo ? this.modals.data.scoreInfo.reviewCount : 0}</strong>
                        </div>
                        <div className="rw-product-card-stat">
                          <span className="rw-product-card-stat-label">평점</span>
                          <div className="rw-product-card-rating">
                            <span className="rw-star-y">★</span>
                            <strong><AvgScore scoreInfo={this.modals.data.scoreInfo}/></strong>
                          </div>
                        </div>
                      </div>
                      <div className="rw-product-card-notice">
                        <FeatherIcon icon="info" size="11" aria-hidden="true" />
                        본 리뷰 작성에 대한 책임은 작성자에게 있습니다
                      </div>
                    </div>

                    {/* 상품 옵션 선택 — 옵션이 있는 상품만 표시 (cafe24 조회) */}
                    {this.optionsLoading && (
                      <div className="rw-option-loading">
                        <FeatherIcon icon="loader" size="13" aria-hidden="true" /> 상품 옵션 불러오는 중...
                      </div>
                    )}
                    {!this.optionsLoading && this.productOptionDefs.length > 0 && (
                      <div className="rw-option-box">
                        <div className="rw-option-box-title">
                          <FeatherIcon icon="sliders" size="13" aria-hidden="true" /> 옵션 선택
                        </div>
                        <div className="rw-option-grid">
                          {this.productOptionDefs.map(def => (
                            <div className="rw-option-field" key={def.name}>
                              <label className="rw-label">
                                {def.name}{def.required && <span className="rw-required"> *</span>}
                              </label>
                              <FormSelect value={this.selectedOptions[def.name] || ''}
                                          onChange={(e) => this.onChangeOption(def.name, e.target.value)}>
                                <option value="">선택 안 함</option>
                                {def.values.map(v => <option key={v} value={v}>{v}</option>)}
                              </FormSelect>
                            </div>
                          ))}
                        </div>
                        {this.newReview.orderProductOptions ? (
                          <div className="rw-option-preview">
                            저장될 옵션값: <strong>{this.newReview.orderProductOptions}</strong>
                          </div>
                        ) : null}
                      </div>
                    )}
                  </section>
                )}

                {/* === 5단계: 리뷰 내용 === */}
                <section className="rw-section">
                  <div className="rw-section-title">
                    <FeatherIcon icon="edit-3" size="14" aria-hidden="true" />
                    리뷰 내용
                  </div>

                  {/* 날짜/시간 */}
                  <div className="rw-form-group">
                    <label className="rw-label">작성 일시</label>
                    <div className="rw-datetime-row">
                      <DateTimePicker value={this.newReview.displayAt} onChange={date => this.onChangeCalendarValue(date, 'displayAt')} />
                      <button type="button" className="rw-now-btn"
                              onClick={() => this.setNowDateTime('displayAt')}>
                        <FeatherIcon icon="clock" size="12" aria-hidden="true" />
                        현재 시간
                      </button>
                    </div>
                    <div className="rw-quick-chips">
                      <button type="button" className="rw-quick-chip" onClick={() => this.onAddDateTime(5, 'm', 'displayAt')}>+5분</button>
                      <button type="button" className="rw-quick-chip" onClick={() => this.onAddDateTime(30, 'm', 'displayAt')}>+30분</button>
                      <button type="button" className="rw-quick-chip" onClick={() => this.onAddDateTime(2, 'h', 'displayAt')}>+2시간</button>
                      <button type="button" className="rw-quick-chip" onClick={() => this.onAddDateTime(6, 'h', 'displayAt')}>+6시간</button>
                      <button type="button" className="rw-quick-chip" onClick={() => this.onAddDateTime(1, 'd', 'displayAt')}>+1일</button>
                    </div>
                  </div>

                  {/* 작성자 ID + 닉네임 1행 2열 */}
                  <div className="rw-form-row">
                    <div className="rw-form-group rw-form-half">
                      <label className="rw-label">작성자 ID <span className="rw-label-meta">(선택)</span></label>
                      <div className="rw-input-with-action">
                        <FormInput name="writerId"
                                   placeholder="작성자 ID"
                                   value={this.newReview.writerId || ''}
                                   onChange={(e) => this.onChangeValue(e)}/>
                        <button type="button" className="rw-input-action-btn"
                                onClick={() => this.regenerateWriterId()}
                                aria-label="작성자 ID 재생성">
                          <FeatherIcon icon="refresh-cw" size="12" />
                        </button>
                      </div>
                    </div>
                    <div className="rw-form-group rw-form-half">
                      <label className="rw-label">작성자 닉네임 <span className="rw-required">*</span></label>
                      <FormInput name="writerName"
                                 placeholder="작성자 닉네임"
                                 value={this.newReview.writerName || ''}
                                 onChange={(e) => this.onChangeValue(e)}/>
                    </div>
                  </div>

                  {/* 리뷰 내용 textarea + 글자수 */}
                  <div className="rw-form-group">
                    <label className="rw-label">리뷰 내용 <span className="rw-required">*</span></label>
                    <div className="rw-textarea-wrap">
                      <FormTextarea name="contents"
                                    placeholder="상품에 대한 솔직한 리뷰를 작성해 주세요."
                                    value={this.newReview.contents || ''}
                                    onChange={(e) => this.onChangeValue(e)}
                                    rows={5}/>
                      <div className="rw-char-counter">
                        {(this.newReview.contents || '').length}자
                      </div>
                    </div>
                  </div>
                </section>

                {/* === 6단계: 별점 인터랙티브 컴포넌트 === */}
                <section className="rw-section">
                  <div className="rw-section-title">
                    <FeatherIcon icon="star" size="14" aria-hidden="true" />
                    별점
                  </div>
                  <div className="rw-rating-grid">
                    {/* 상품 별점 */}
                    <div className="rw-rating-card">
                      <div className="rw-rating-card-label">상품 별점</div>
                      <div className="rw-rating-stars" role="radiogroup" aria-label="상품 별점 5점 만점">
                        {[1,2,3,4,5].map(n => {
                          const value = n * 20;
                          const current = parseInt(this.newReview.goodsPt) || 0;
                          const hovered = this.hoveredGoodsPt;
                          const display = hovered > 0 ? hovered : current;
                          const isFilled = value <= display;
                          return (
                            <button key={n} type="button"
                                    role="radio"
                                    aria-checked={current === value}
                                    aria-label={`상품 별점 5점 만점 중 ${n}점`}
                                    className={`rw-star-btn ${isFilled ? 'is-filled' : ''}`}
                                    onMouseEnter={() => this.setHoverRating('goodsPt', value)}
                                    onMouseLeave={() => this.setHoverRating('goodsPt', 0)}
                                    onClick={() => this.setRating('goodsPt', value)}>
                              ★
                            </button>
                          );
                        })}
                        <span className="rw-rating-value">
                          {((parseInt(this.newReview.goodsPt) || 0) / 20).toFixed(1)} / 5.0
                        </span>
                      </div>
                    </div>
                    {/* 배송 별점 — 배송 평가 사용 설정이 켜져 있을 때만 노출 */}
                    {this.teamUser.basicSettings && this.teamUser.basicSettings.isDeliveryRating && (
                      <div className="rw-rating-card">
                        <div className="rw-rating-card-label">배송 별점</div>
                        <div className="rw-rating-stars" role="radiogroup" aria-label="배송 별점 5점 만점">
                          {[1,2,3,4,5].map(n => {
                            const value = n * 20;
                            const current = parseInt(this.newReview.deliveryPt) || 0;
                            const hovered = this.hoveredDeliveryPt;
                            const display = hovered > 0 ? hovered : current;
                            const isFilled = value <= display;
                            return (
                              <button key={n} type="button"
                                      role="radio"
                                      aria-checked={current === value}
                                      aria-label={`배송 별점 5점 만점 중 ${n}점`}
                                      className={`rw-star-btn ${isFilled ? 'is-filled' : ''}`}
                                      onMouseEnter={() => this.setHoverRating('deliveryPt', value)}
                                      onMouseLeave={() => this.setHoverRating('deliveryPt', 0)}
                                      onClick={() => this.setRating('deliveryPt', value)}>
                                ★
                              </button>
                            );
                          })}
                          <span className="rw-rating-value">
                            {((parseInt(this.newReview.deliveryPt) || 0) / 20).toFixed(1)} / 5.0
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </section>

                {/* === 7단계: 설문 섹션 리디자인 === */}
                {this.teamUser.basicSettings && this.teamUser.basicSettings.surveyConfig && this.teamUser.basicSettings.surveyConfig.enableSurvey === 'yes' && this.productSurvey && this.productSurvey.length > 0 && (
                  <section className="rw-section">
                    <div className="rw-section-title">
                      <FeatherIcon icon="clipboard" size="14" aria-hidden="true" />
                      설문 응답
                    </div>
                    <div className="rw-survey-list">
                      {this.productSurvey.map((group, groupIdx) => (
                        <div key={groupIdx} className="rw-survey-group">
                          <div className="rw-survey-group-header">
                            <span className="rw-survey-group-title">{group.name}</span>
                            {group.isCommon && (
                              <span className="rw-survey-common-badge">공통</span>
                            )}
                          </div>

                          {(!group.item_ids || group.item_ids.length === 0) && (
                            <p className="rw-survey-empty">등록된 질문이 없습니다.</p>
                          )}

                          {group.item_ids && group.item_ids.length > 0 && typeof group.item_ids[0] === 'object' && group.item_ids.map((item, itemIdx) => {
                            const questionType = item.options && item.options.questionType ? item.options.questionType : 'text';
                            const choices = item.options && (item.options.choices || item.options.answerOptions) ? (item.options.choices || item.options.answerOptions) : [];
                            const isRequired = item.options && item.options.required;

                            return (
                              <div key={itemIdx} className="rw-survey-item">
                                <label className="rw-survey-question">
                                  {item.name}
                                  {isRequired
                                    ? <span className="rw-required">*</span>
                                    : <span className="rw-optional">(선택)</span>}
                                </label>

                                {questionType === 'text' && (
                                  <FormInput placeholder="답변을 입력해주세요"
                                             value={this.surveyAnswers[item._id] || ''}
                                             onChange={(e) => this.onChangeSurveyAnswer(item._id, e.target.value, 'text')}/>
                                )}

                                {questionType === 'textarea' && (
                                  <FormTextarea placeholder="답변을 입력해주세요"
                                                value={this.surveyAnswers[item._id] || ''}
                                                onChange={(e) => this.onChangeSurveyAnswer(item._id, e.target.value, 'textarea')}
                                                rows={3}/>
                                )}

                                {questionType === 'radio' && choices.length > 0 && (
                                  <div className="rw-survey-chips" role="radiogroup" aria-label={item.name}>
                                    {choices.map((opt, optIdx) => {
                                      const selected = this.surveyAnswers[item._id] === opt;
                                      return (
                                        <button key={optIdx} type="button"
                                                role="radio"
                                                aria-checked={selected}
                                                className={`rw-survey-chip ${selected ? 'is-selected' : ''}`}
                                                onClick={() => this.onChangeSurveyAnswer(item._id, opt, 'radio')}>
                                          {selected && <FeatherIcon icon="check" size="11" aria-hidden="true" />}
                                          {opt}
                                        </button>
                                      );
                                    })}
                                  </div>
                                )}

                                {questionType === 'checkbox' && choices.length > 0 && (
                                  <div className="rw-survey-chips">
                                    {choices.map((opt, optIdx) => {
                                      const isChecked = this.surveyAnswers[item._id] && this.surveyAnswers[item._id].includes(opt);
                                      return (
                                        <button key={optIdx} type="button"
                                                aria-pressed={isChecked}
                                                className={`rw-survey-chip ${isChecked ? 'is-selected' : ''}`}
                                                onClick={() => this.onChangeSurveyAnswer(item._id, opt, 'checkbox', item.options.maxSelections)}>
                                          {isChecked && <FeatherIcon icon="check" size="11" aria-hidden="true" />}
                                          {opt}
                                        </button>
                                      );
                                    })}
                                    {item.options && item.options.maxSelections && (
                                      <span className="rw-survey-hint">(최대 {item.options.maxSelections}개 선택)</span>
                                    )}
                                  </div>
                                )}

                                {questionType === 'rating' && (
                                  <div className="rw-rating-stars rw-rating-stars-inline" role="radiogroup" aria-label={item.name}>
                                    {[1,2,3,4,5].map(n => {
                                      const value = n * 20;
                                      const current = this.surveyAnswers[item._id] || 0;
                                      const isFilled = value <= current;
                                      return (
                                        <button key={n} type="button"
                                                role="radio"
                                                aria-checked={current === value}
                                                aria-label={`${item.name} 별점 ${n}`}
                                                className={`rw-star-btn ${isFilled ? 'is-filled' : ''}`}
                                                onClick={() => this.onChangeSurveyAnswer(item._id, value, 'rating')}>
                                          ★
                                        </button>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  </section>
                )}

                {/* === 8단계: 미디어 업로드 === */}
                <section className="rw-section">
                  <div className="rw-section-title">
                    <FeatherIcon icon="image" size="14" aria-hidden="true" />
                    미디어 첨부
                  </div>
                  <div
                    className={`rw-upload-area ${this.isDragOverUpload ? 'is-dragging' : ''}`}
                    onClick={this.handleDropAreaClick}
                    onDragEnter={this.handleDragOverUpload}
                    onDragOver={this.handleDragOverUpload}
                    onDragLeave={this.handleDragLeaveUpload}
                    onDrop={this.handleDropUpload}
                    role="button"
                    tabIndex={0}>
                    <div className="rw-upload-icon">
                      <FeatherIcon icon="upload-cloud" size="40" aria-hidden="true" />
                    </div>
                    <div className="rw-upload-title">파일을 드래그하거나 클릭하여 업로드</div>
                    <div className="rw-upload-hint">이미지, MP4, MOV 지원 · 영상은 자동으로 WEBP로 변환됩니다</div>
                  </div>
                  <input
                    type="file"
                    id="upload"
                    name="file"
                    accept="image/*,video/mp4,video/quicktime"
                    multiple
                    ref={this.fileInputRef}
                    style={{display: 'none'}}
                    onChange={(e) => this.onFileUpload(e)}
                  />

                  {/* 업로드된 파일 카드 리스트 */}
                  {((this.newReview.thumbs && this.newReview.thumbs.length > 0) ||
                    (this.newReview.images && this.newReview.images.length > 0) ||
                    (this.newReview.movies && this.newReview.movies.length > 0)) && (
                    <div className="rw-upload-files">
                      <div className="rw-upload-files-header">업로드된 파일</div>
                      <ul className="rw-upload-files-list">
                        {this.newReview && this.newReview.movies && this.newReview.movies.length > 0 && this.newReview.movies.map((item, i) => (
                          <li key={`mv-${i}`}>
                            <img src={"https://customer-9lljf7xk3rrg9o6q.cloudflarestream.com/" + (typeof item === 'object' ? item.src : item) + "/thumbnails/thumbnail.gif?width=150&height=150&time=1s&duration=5s"}
                                 alt="동영상 썸네일" />
                            <button type="button" className="rw-upload-remove"
                                    onClick={() => this.onClickMediaRemove(item, i, 'movies')}
                                    aria-label="파일 제거">
                              <FeatherIcon icon="x" size="11"/>
                            </button>
                          </li>
                        ))}
                        {this.newReview && this.newReview.thumbs && this.newReview.thumbs.length > 0 ? this.newReview.thumbs.map((thumb, i) => {
                          const imageItem = this.newReview.images && this.newReview.images[i] ? this.newReview.images[i] : thumb;
                          return (
                            <li key={`th-${i}`}>
                              <img src={thumb.url} alt="이미지" />
                              <button type="button" className="rw-upload-remove"
                                      onClick={() => this.onClickMediaRemove(imageItem, i, 'images')}
                                      aria-label="파일 제거">
                                <FeatherIcon icon="x" size="11"/>
                              </button>
                            </li>
                          );
                        }) : this.newReview && this.newReview.images && this.newReview.images.length > 0 && this.newReview.images.map((imageItem, i) => (
                          <li key={`im-${i}`}>
                            <img src={imageItem.url} alt="이미지"/>
                            <button type="button" className="rw-upload-remove"
                                    onClick={() => this.onClickMediaRemove(imageItem, i, 'images')}
                                    aria-label="파일 제거">
                              <FeatherIcon icon="x" size="11"/>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* === 배경 제거 옵션 (RMBG-1.4 브라우저 단) === */}
                  <div className="rw-bg-removal-card">
                    <div className="rw-bg-removal-head">
                      <div className="rw-bg-removal-icon" aria-hidden="true">
                        <FeatherIcon icon="scissors" size="16" />
                      </div>
                      <div className="rw-bg-removal-meta">
                        <div className="rw-bg-removal-title">
                          이미지 배경 자동 제거
                          <span className="rw-bg-removal-tag">RMBG-1.4</span>
                        </div>
                        <div className="rw-bg-removal-desc">
                          업로드 전에 브라우저에서 이미지 배경을 자동으로 제거합니다 (로컬 처리, 서버 전송 없음)
                        </div>
                      </div>
                      <button type="button"
                              className={`rw-switch ${this.bgRemovalEnabled ? 'is-on' : ''}`}
                              onClick={() => this.toggleBgRemoval()}
                              role="switch"
                              aria-checked={this.bgRemovalEnabled}
                              aria-label="이미지 배경 자동 제거 토글">
                        <span className="rw-switch-track">
                          <span className="rw-switch-thumb" aria-hidden="true" />
                        </span>
                      </button>
                    </div>

                    {this.bgRemovalEnabled && (
                      <div className="rw-bg-removal-status">
                        {this.bgRemovalModelLoading ? (
                          <div className="rw-bg-removal-loading">
                            <FeatherIcon icon="download" size="12" aria-hidden="true" />
                            <span>모델 다운로드 중... ({this.bgRemovalLoadProgress}%)</span>
                            <div className="rw-bg-removal-progress">
                              <div className="rw-bg-removal-progress-fill" style={{width: `${this.bgRemovalLoadProgress}%`}} />
                            </div>
                          </div>
                        ) : this.bgRemovalProcessing ? (
                          <div className="rw-bg-removal-loading">
                            <FeatherIcon icon="loader" size="12" aria-hidden="true" className="rw-spin" />
                            <span>
                              배경 제거 중... ({this.bgRemovalProgress.current}/{this.bgRemovalProgress.total})
                              {this.bgRemovalProgress.fileName && <em>{this.bgRemovalProgress.fileName}</em>}
                            </span>
                          </div>
                        ) : this._bgRemovalCache && this._bgRemovalCache.model ? (
                          <div className="rw-bg-removal-ready">
                            <FeatherIcon icon="check-circle" size="12" aria-hidden="true" />
                            <span>모델 준비 완료. 다음 업로드되는 이미지의 배경을 자동으로 제거합니다.</span>
                          </div>
                        ) : (
                          <div className="rw-bg-removal-info">
                            <FeatherIcon icon="info" size="12" aria-hidden="true" />
                            <span>최초 사용 시 약 80MB 모델을 다운로드합니다. 이후엔 브라우저에 캐시되어 즉시 동작합니다.</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </section>
              </div>

              {/* === 3단계: Sticky Footer === */}
              <div className="rw-modal-footer">
                {!this.warningAgreed && (
                  <div className="rw-modal-footer-hint">
                    <FeatherIcon icon="alert-circle" size="12" aria-hidden="true" />
                    유의사항에 동의해야 작성할 수 있습니다
                  </div>
                )}
                <Button theme="light"
                        onClick={() => this.modals.isWriteForm = false}>
                  닫기
                </Button>
                <Button theme="primary"
                        className="rw-submit-btn"
                        disabled={this.isUploading || !this.warningAgreed}
                        onClick={() => this.updateReview(this.modals.data)}
                        title={!this.warningAgreed ? '유의사항에 먼저 동의해 주세요' : ''}>
                  <FeatherIcon icon="check" size="14" aria-hidden="true" />
                  리뷰 작성
                </Button>
              </div>
            </ModalBody>
          </Modal>
          <ModalLoading isLoading={this.isLoading || this.isUploading} />
        </div>
    )
  }
}

export default ReviewWrite;
